import React from "react";
import {Link} from "react-router-dom";
import IntlMessages from "util/IntlMessages";


const Error401 = () => (
    
  <div className="gx-page-error-container">
    <div className="gx-page-error-content">
      <div className="gx-error-code gx-mb-4">401</div>
      <h2 className="gx-text-center">
        <p>Not Authorized</p>
      </h2>
      <p className="gx-text-center">
        <Link className="gx-btn gx-btn-primary"  onClick={() => { localStorage.removeItem("token"); localStorage.removeItem("uuid"); localStorage.removeItem("user_role");
          localStorage.removeItem("loged_in_to");localStorage.removeItem("all_roles");}} to="/portals">Log Out</Link>
      </p>
    </div>
  </div>
);

export default Error401;